/**
 * Sort data by the given column.
 * @param data {object[]}
 * @param column {string|null}
 * @param order {string|null}
 * @param asNumber {boolean}
 * @returns {object[]}
 * @constructor
 */
export default function sort(data, column, order = null, asNumber = false) {
    const factor = order === SortDirection.ASC ? 1 : -1;
    const compare = asNumber
        ? (a, b) => factor * (a[column] - b[column])
        : (a, b) => factor * a[column].toString().localeCompare(b[column].toString());
    return [...data].sort(compare);
}

export const SortDirection = {
    ASC: 'asc',
    DESC: 'desc',
    invert: (old) => {
        return old === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
    }
}
